import React, { useEffect, useState } from "react";
import { MedalBadge } from "./ProfileStats";
import { t } from "../i18n";

const TIER_MARKS = ["0", "I", "II", "III", "IV", "V"];

// La fiche d'une médaille, en petite fenêtre : la médaille en grand, son nom,
// son palier et ce qu'il faut faire pour l'avoir. Voir showMedal().
export default function MedalPopup() {
  const [shown, setShown] = useState(null);

  useEffect(() => {
    const onShow = (e) => setShown(e.detail);
    const onKey = (e) => { if (e.key === "Escape") setShown(null); };
    window.addEventListener("pq:medal-show", onShow);
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("pq:medal-show", onShow);
      window.removeEventListener("keydown", onKey);
    };
  }, []);

  if (!shown) return null;
  const { medal: m, action } = shown;
  const hidden = !m.unlocked && m.secret;
  const tiered = (m.tierCount || 1) > 1 && m.unlocked;

  return (
    <div className="medal-pop-overlay" onClick={() => setShown(null)}>
      <div className="medal-pop" role="dialog" aria-modal="true" onClick={e => e.stopPropagation()}>
        <MedalBadge medal={m} size={96} />
        <h3 className="medal-pop-name">{hidden ? t("medals.secretName") : m.name}</h3>
        {tiered && <span className="medal-pop-tier">{t("medals.toastTier", { tier: TIER_MARKS[m.tier] || "0" })}</span>}
        {/* Gravée : ce qui a été fait, puis — plus discret — le palier suivant.
            Pas encore : l'objectif à atteindre. */}
        <p className="medal-pop-desc">
          {hidden ? t("medals.secretHint") : m.unlocked ? (m.achieved || m.cond || "") : (m.cond || "")}
        </p>
        {m.unlocked && m.nextGoal && (
          <p className="medal-pop-next">{t("medals.nextTier", { goal: m.nextGoal })}</p>
        )}
        {!m.unlocked && !hidden && <p className="medal-pop-locked">{t("medals.popLocked")}</p>}
        <div className="medal-pop-actions">
          {action && (
            <button type="button" className="btn btn-primary"
              onClick={() => { action.onClick(); setShown(null); }}>{action.label}</button>
          )}
          <button type="button" className="btn" onClick={() => setShown(null)}>{t("common.close")}</button>
        </div>
      </div>
    </div>
  );
}
